<template>
  <div class="onboarding-static-page-container">
      <OnboardingMenu class="menu" :logo="logoUrl" :languages="languageOptions" :menus="menuOptions"></OnboardingMenu>
      <div class="header">
        <p>{{ $t('onboarding.nestle.myFirstDayPageCN.title') }}</p>
      </div>
      <div class="body">
        <div class="text-board clear-margin-top">
          <p class="board-title">{{ $t('onboarding.nestle.myFirstDayPageCN.china') }}</p>
          <p class="board-subtitle">{{ $t('onboarding.nestle.myFirstDayPageCN.information') }}</p>
        </div>
        <div class="image-board clear-margin-top">
          <img :src="firstImgUrl" alt="" @click="toOutSide('http://www.nestle.com.cn/')">
          <div class="content">
            <p class="board-title">{{ $t('onboarding.nestle.myFirstDayPageCN.chinaWebSite') }}</p>
            <p class="board-subtitle"></p>
          </div>
        </div>
        <div class="image-board flex-derection-row-reverse" @click="toOutSide('http://www.linkedin.com/company/nestle-s-a-/')">
          <img :src="secondImgUrl" alt="">
          <div class="content">
            <p class="board-title">{{ $t('onboarding.nestle.myFirstDayPageCN.linkedIn') }}</p>
            <p class="board-subtitle"></p>
          </div>
        </div>
        <div class="image-board" @click="toOutSide('https://j.map.baidu.com/SOoRP')">
          <img :src="thirdImgUrl" alt="">
          <div class="content">
            <p class="board-title">{{ $t('onboarding.nestle.myFirstDayPageCN.gcrOffice') }}</p>
            <p class="board-subtitle"></p>
          </div>
        </div>
        <div class="image-board flex-derection-row-reverse">
          <img :src="fourthImgUrl" alt="">
          <div class="content">
            <p class="board-title">{{ $t('onboarding.nestle.myFirstDayPageCN.cnWechatQR1') }}</p>
            <p class="board-subtitle"></p>
          </div>
        </div>
        <div class="image-board">
          <img :src="fifthImgUrl" alt="">
          <div class="content">
            <p class="board-title">{{ $t('onboarding.nestle.myFirstDayPageCN.cnWechatQR2') }}</p>
            <p class="board-subtitle"></p>
          </div>
        </div>
        <div class="follow">
          <p v-html="$t('onboarding.nestle.followUs')"></p>
          <p>{{ $t('onboarding.nestle.donnotBeShared') }}</p>
        </div>
      </div>
      <Footer></Footer>
  </div>
</template>

<script>
import { onboardingMixin } from '@/components/onboarding/form/mixin.js'
import OnboardingMenu from '@/components/onboarding/form/Menu'
import Footer from '@/components/onboarding/form/Footer'
import { deviceType } from '@/utils/common'

export default {
  mixins: [onboardingMixin],
  components: {
    OnboardingMenu, Footer
  },
  data () {
    const isMobile = deviceType.isMobile
    return {
      firstImgUrl: require(isMobile ? '@/assets/image/onboarding/my-first-day/h5/china/website.jpg' : '@/assets/image/onboarding/my-first-day/pc/china/website.jpg'),
      secondImgUrl: require(isMobile ? '@/assets/image/onboarding/my-first-day/h5/china/linkedIn.jpg' : '@/assets/image/onboarding/my-first-day/pc/china/linkedIn.jpg'),
      thirdImgUrl: require(isMobile ? '@/assets/image/onboarding/my-first-day/h5/china/office.jpg' : '@/assets/image/onboarding/my-first-day/pc/china/office.jpg'),
      fourthImgUrl: require(isMobile ? '@/assets/image/onboarding/my-first-day/h5/china/QR-1.jpg' : '@/assets/image/onboarding/my-first-day/pc/china/QR-1.jpg'),
      fifthImgUrl: require(isMobile ? '@/assets/image/onboarding/my-first-day/h5/china/QR-2.jpg' : '@/assets/image/onboarding/my-first-day/pc/china/QR-2.jpg')
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
@import '@/assets/scss/onboarding-static-page.scss';

.onboarding-static-page-container {
  .header {
    background-image: url('~@/assets/image/onboarding/my-first-day/h5/banner.jpg');
  }
}

/* 中型设备（台式电脑） */
@media (min-width: 769px) {
  .onboarding-static-page-container {
    .header {
      background-image: url('~@/assets/image/onboarding/my-first-day/pc/banner.jpg');
    }
  }
}
</style>
